// --- Core ---
import {createSlice} from "@reduxjs/toolkit";

interface HotkeysState {
  isOverlayDisplayed: boolean,
  isSpotlightDisplayed: boolean
}

const initialState: HotkeysState = {
  isOverlayDisplayed: false,
  isSpotlightDisplayed: false
};

const hotkeysSlice = createSlice({
  // eslint-disable-next-line formatjs/no-literal-string-in-object
  name: 'hotkeys',
  initialState,
  reducers: {
    toggleHotkeysOverlay: (state) => {
      state.isOverlayDisplayed = !state.isOverlayDisplayed;
    },
    toggleSpotlight: (state) => {
      state.isSpotlightDisplayed = !state.isSpotlightDisplayed;
    },
    hideSpotlight: (state) => {
      state.isSpotlightDisplayed = false;
    }
  }
});

export const {toggleHotkeysOverlay, toggleSpotlight, hideSpotlight} = hotkeysSlice.actions;

export default hotkeysSlice.reducer;
